import styled from 'styled-components';
import { breakpoints } from '../../theme';

export const KimeraVisionContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  width: 102vw;
  margin-left: calc(-50vw + 50%);
  padding: 4rem 2rem;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    min-height: 60vh;
    padding: 3rem 1.5rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    min-height: 50vh;
    padding: 2rem 1rem;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
`;

export const TVContainer = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OffScreenImage = styled.img`
  position: absolute;
  width: 78%;
  height: 64%;
  top: 14%;
  left: 11%;
  object-fit: cover;
  z-index: 3;
  border-radius: 8px;
  
  @media (max-width: ${breakpoints.tablet}) {
    width: 78%;
    height: 64%;
    top: 14%;
    left: 11%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 78%;
    height: 64%;
    top: 14%;
    left: 11%;
  }
`;

export const VideoOverlay = styled.video`
  position: absolute;
  width: 78%;
  height: 53%;
  top: 14%;
  left: 11%;
  object-fit: cover;
  z-index: 5;
  border-radius: 8px;
  
  @media (max-width: ${breakpoints.tablet}) {
    width: 78%;
    height: 64%;
    top: 9%;
    left: 11%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 78%;
    height: 64%;
    top: 9%;
    left: 11%;
  }
`;

export const TVImage = styled.img`
  width: clamp(400px, 50vw, 700px);
  height: auto;
  max-width: 100%;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.8));
  position: relative;
  z-index: 10;
  
  @media (max-width: ${breakpoints.tablet}) {
    width: clamp(350px, 60vw, 500px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: clamp(280px, 85vw, 400px);
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  bottom: 11%;
  left: 11%;
  width: 78%;
  height: 15%;
  z-index: 15;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2%;
  @media (max-width: ${breakpoints.mobile}) {
    margin-left: -15px
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ControlButton = styled.img`
  width: clamp(40px, 4vw, 60px);
  height: auto;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: ${breakpoints.tablet}) {
    width: clamp(35px, 4.5vw, 50px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: clamp(30px, 5vw, 45px);
  }
`;

export const InactiveControlButton = styled.img`
  width: clamp(40px, 4vw, 60px);
  height: auto;
  cursor: default;
  pointer-events: none;

  @media (max-width: ${breakpoints.tablet}) {
    width: clamp(35px, 4.5vw, 50px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: clamp(30px, 5vw, 45px);
  }
`;
